<template>
  <div id="Shipping" class="accessRequest">
    <MyBanner :text="$t('banner.accessDcInitTicket')" />
    <MyHeaderPage
      :title="$t('accessDc.title')"
      :subtitle="$t('accessDc.subTitle')"
    />

    <p class="intro-text" v-if="isBio" v-html="$t('accessDc.infoTitle')"></p>
    <div class="list-container" v-if="isBio">
      <p
        class="infoContentTitle marginBottom0"
        v-html="$t('accessDc.infoContentTitle')"
      ></p>
      <div class="lists-content" v-html="$t('accessDc.infoContent')"></div>
    </div>

    <div
      v-if="!hasColocation && viewLoader"
      style="
        margin: 20px 0;
        text-align: center;
        font-size: 18px;
        color: #001831;
      "
    >
      {{ $t("noSolutionsServices.colocation") }}
    </div>

    <MyLoading :viewLoader="viewLoader" type="" />
    <br /><br />
    <div class="typeShipping" v-if="hasColocation">
      <div
        class="card"
        v-for="(dc, indexDc) in dc_list"
        :key="indexDc"
        :class="{ opacity: !dc.available }"
      >
        <div class="cardContent">
          <h3>{{ dc.dc_name }}</h3>
          <p class="text">{{ $t("accessDc.cardOneText" + dc.dc_id) }}</p>
          <div class="contentButton">
            <div
              class="cdlButton"
              @click="dc.available ? setAccess(dc) : null"
              :id="'dc-' + indexDc"
              style="width: 87%"
            >
              {{ $t("accessDc.requestBtn") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <br /><br /><br /><br />
  </div>
</template>

<script>
import MyBanner from "@/components/MyBanner.vue";
import MyHeaderPage from "@/components/MyHeaderPage.vue";
import MyLoading from "@/components/MyLoading.vue";
import "@/assets/scss/Shipping.scss";
import "@/assets/scss/AccessRequest.scss";
import { useAccessDcStore } from "@/stores/AccessDcStore";

export default {
  name: "MyAccessRequest",
  components: {
    MyBanner,
    MyHeaderPage,
    MyLoading,
  },
  data() {
    return {
      dc_list: [],
      viewLoader: false,
      isBio: false,
      hasColocation: false,
    };
  },
  methods: {
    setAccess(dc) {
      let accessDc = useAccessDcStore();
      accessDc.form.dc.dc_id = dc.dc_id;
      accessDc.form.dc.dc_name = dc.dc_name;
      accessDc.form.dc.address = dc.dc_address;
      return this.$router.push({
        name: "AccessRequestForm" + this.$i18n.locale,
      });
    },
    async checkColocationAssets() {
      try {
        const token = this.$keycloak.idToken;
        const baseUrl = window.VUE_APP_MISTRA_URL;

        const response = await this.axios.get(
          `${baseUrl}assets/v1/has-assets/colocation`,
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        this.hasColocation = response.data.hasAssets || false;
      } catch (error) {
        console.error("Error checking colocation assets:", error);
        this.hasColocation = false;
      }
    },
  },
  async mounted() {
    window.scrollTo(0, 0);
    let accessDc = useAccessDcStore();
    accessDc.resetAccess();

    // Check colocation assets first
    await this.checkColocationAssets();

    let he = {
      Accept: "application/json",
      Authorization: "Bearer " + this.$keycloak.idToken,
    };

    this.axios
      .get(
        window.VUE_APP_MISTRA_URL +
          "tickets/v1/service-dc-details?service=Shipping",
        { headers: he }
      )
      .then((response) => {
        this.dc_list = response.data;
        this.viewLoader = true;
      })
      .catch((err) => {
        console.log(err);
        this.viewLoader = true;
      });

    if (localStorage.getItem("cdlAccessDc")) {
      accessDc.form = JSON.parse(localStorage.getItem("cdlAccessDc")).accessDc;
      accessDc.isCompleted = true;
      return this.$router.push({
        name: "AccessRequestSummary" + this.$i18n.locale,
      });
    } else {
      localStorage.removeItem("cdlAccessDc");
      localStorage.removeItem("cdlAccessDcSteps");
      localStorage.removeItem("cdlAccessDcStepsGoTo");
      localStorage.removeItem("accessDc");
      localStorage.removeItem("accessCoWo");
    }

    let accessStore = useAccessDcStore();
    this.isBio = accessStore.isBio;
  },
};
</script>
